module.exports = __webpack_public_path__ + "static/media/logo.968f5cbb.svg";